import { Box, Divider, Drawer, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { TimeOfDayFilter } from "../deals/dealList/filters/TimeOfDayFilter";
import { AreaFilter } from "../deals/dealList/filters/AreaFilter";
import { CategoryFilterSection } from "../deals/dealList/filters/CategoryFilterSection";
import DiscountTypeFilter from "../deals/dealList/filters/DiscountTypeFilter";
import CustomButton from "../ui/CustomButton";
import { uiNeutrals } from "../../constants/uiNeutrals";
import { closeIconButtonSx } from "../../constants/closeIconButtonSx";
import { appBackgroundColor } from "../../theme";

const filterSheetPaperSx = {
  bgcolor: appBackgroundColor,
};

const FilterPage = ({
  isOpen,
  onClose,
  tempFilters,
  tempCurrentArea,
  onTimeOfDayChange,
  onAreaChange,
  onCategoryChange,
  onDiscountFilterChange,
  onGetCurrentLocation,
  onApply,
}) => {
  return (
    <Drawer
      anchor="bottom"
      open={isOpen}
      onClose={onClose}
      sx={{ zIndex: 10000 }}
      ModalProps={{
        keepMounted: false,
      }}
      PaperProps={{
        elevation: 0,
        sx: {
          maxHeight: "min(92dvh, 880px)",
          width: "100%",
          maxWidth: "100%",
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          ...filterSheetPaperSx,
          borderTop: uiNeutrals.frostedToggleBorder,
          boxShadow: "0 -10px 36px rgba(0, 0, 0, 0.1)",
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(255, 255, 255, 0.2)",
          backdropFilter: "blur(5px) saturate(1.05)",
          WebkitBackdropFilter: "blur(5px) saturate(1.05)",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1.5,
          py: 1.25,
          px: 2,
          flexShrink: 0,
          bgcolor: "transparent",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.75,
            minWidth: 0,
            flex: 1,
          }}
        >
          <IconButton
            onClick={onClose}
            edge="start"
            aria-label="Close filters"
            sx={{ ...closeIconButtonSx, ml: 0 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 600,
              color: "#000",
              minWidth: 0,
            }}
          >
            Filter
          </Typography>
        </Box>
        <CustomButton
          variant="primary"
          onClick={onApply}
          preventSpam={false}
          sx={{
            flexShrink: 0,
            py: 0.4,
            fontSize: "14px",
            lineHeight: 1.2,
            minHeight: 34,
          }}
        >
          Save
        </CustomButton>
      </Box>

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
          px: 2,
          pb: 2,
          WebkitOverflowScrolling: "touch",
          touchAction: "pan-y",
          overscrollBehavior: "contain",
          bgcolor: "transparent",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          msOverflowStyle: "none",
          scrollbarWidth: "none",
        }}
      >
        <AreaFilter
          value={tempFilters.area}
          tempCurrentArea={tempCurrentArea}
          onChange={onAreaChange}
          onGetCurrentLocation={onGetCurrentLocation}
          isMobile={true}
        />
        <Divider sx={{ borderColor: uiNeutrals.rowDivider, my: 2 }} />
        <Box sx={{ mb: 0 }}>
          <CategoryFilterSection
            value={tempFilters.category || ""}
            onChange={onCategoryChange}
            isMobile={true}
          />
        </Box>
        <Divider sx={{ borderColor: uiNeutrals.rowDivider, my: 2 }} />
        <DiscountTypeFilter
          discountType={tempFilters.discountType || ""}
          priceBand={tempFilters.priceBand || ""}
          onChange={onDiscountFilterChange}
          isMobile={true}
        />
        <Divider sx={{ borderColor: uiNeutrals.rowDivider, my: 2 }} />
        <Box sx={{ pb: 12 }}>
          <TimeOfDayFilter
            value={tempFilters.timeOfDay}
            onChange={onTimeOfDayChange}
            isMobile={true}
            hideBottomBorder
          />
        </Box>
      </Box>

    </Drawer>
  );
};

export default FilterPage;
